module.exports = __webpack_public_path__ + "img/record12.13aa713d.jpg";